// extracted by mini-css-extract-plugin
module.exports = {"slideData":"_2V1bDdlxwF2CMVqFmA6wV-","slides":"_3bTbnuGkRkF8Bs-g_X6bQS"};